// Action Types para Áreas de Armazenamento

// Listar
export const FETCH_AREAS_REQUEST = '@areasArmazenamento/FETCH_AREAS_REQUEST';
export const FETCH_AREAS_SUCCESS = '@areasArmazenamento/FETCH_AREAS_SUCCESS';
export const FETCH_AREAS_FAILURE = '@areasArmazenamento/FETCH_AREAS_FAILURE';

// Buscar por ID
export const FETCH_AREA_BY_ID_REQUEST = '@areasArmazenamento/FETCH_AREA_BY_ID_REQUEST';
export const FETCH_AREA_BY_ID_SUCCESS = '@areasArmazenamento/FETCH_AREA_BY_ID_SUCCESS';
export const FETCH_AREA_BY_ID_FAILURE = '@areasArmazenamento/FETCH_AREA_BY_ID_FAILURE';

// Criar
export const CREATE_AREA_REQUEST = '@areasArmazenamento/CREATE_AREA_REQUEST';
export const CREATE_AREA_SUCCESS = '@areasArmazenamento/CREATE_AREA_SUCCESS';
export const CREATE_AREA_FAILURE = '@areasArmazenamento/CREATE_AREA_FAILURE';

// Atualizar
export const UPDATE_AREA_REQUEST = '@areasArmazenamento/UPDATE_AREA_REQUEST';
export const UPDATE_AREA_SUCCESS = '@areasArmazenamento/UPDATE_AREA_SUCCESS';
export const UPDATE_AREA_FAILURE = '@areasArmazenamento/UPDATE_AREA_FAILURE';

// Remover
export const DELETE_AREA_REQUEST = '@areasArmazenamento/DELETE_AREA_REQUEST';
export const DELETE_AREA_SUCCESS = '@areasArmazenamento/DELETE_AREA_SUCCESS';
export const DELETE_AREA_FAILURE = '@areasArmazenamento/DELETE_AREA_FAILURE';

// Duplicar
export const DUPLICATE_AREA_REQUEST = '@areasArmazenamento/DUPLICATE_AREA_REQUEST';
export const DUPLICATE_AREA_SUCCESS = '@areasArmazenamento/DUPLICATE_AREA_SUCCESS';
export const DUPLICATE_AREA_FAILURE = '@areasArmazenamento/DUPLICATE_AREA_FAILURE';

// Limpar estados
export const CLEAR_AREA_FORM = '@areasArmazenamento/CLEAR_AREA_FORM';
export const CLEAR_MESSAGES = '@areasArmazenamento/CLEAR_MESSAGES';

// Filtros
export const SET_FILTERS = '@areasArmazenamento/SET_FILTERS';
export const CLEAR_FILTERS = '@areasArmazenamento/CLEAR_FILTERS';